import { render, staticRenderFns } from "./DataCellText.vue?vue&type=template&id=93503e40&"
import script from "./DataCellText.vue?vue&type=script&lang=js&"
export * from "./DataCellText.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports